import React, { Component } from 'react';
import { Table } from "reactstrap";
import {FaTrash} from 'react-icons/fa';
import styles from './ImagesTable.module.css';
import error_triangle_icon from 'Assets/icons/Icons__error.svg';



export default class ImagesTable extends Component {

    render() {
        let { records,display_error, errorImageNames, errorImageTexts } = this.props;
        let table_records, error_record = null;
        error_record = <tr key={900} className={styles.errorRecord}> 
        <td><img src={error_triangle_icon} alt="Trane Logo" height="25px" width="25px" />{" An error has occurred. "}{errorImageNames}{errorImageTexts}</td><td>&nbsp;</td></tr>;


        if (this.props.records != null && this.props.records.length !== 0) {
            table_records = records.map((el,index )=> {
                return <tr key={index} > 
                      <td style={{'text-decoration':'underline','cursor': 'pointer'}} onClick={() => {this.props.onDownloadAttachment(el.fileName)}}>{el.name}</td> 
                      <td style={{textAlign:"right"}}><FaTrash className="Ensemble_Icon link_cursor" style={{ valign: 'bottom' }}  onClick={()=>{this.props.onDeleteAttachment(el.fileName) }}/></td></tr>
            });
        }
        else {
            table_records = <tr><td className={styles.norecords_text}>{"No attachments"}</td><td>{" "}</td></tr>
        }

        return (
            <Table responsive className={styles.greenTable}>
                <tbody>
                    <tr><th>ATTACHMENTS</th><th>{" "}</th></tr>
                    {table_records}
                { (display_error)? error_record :  null }
                     
                </tbody>
            </Table>
        );
    }
}
